import * as React from 'react';
import * as styles from './KokonIcon16.css';

export const KokonIcon16: React.FC = (): React.JSX.Element => {
  return <div className={styles['icon']} />;
};
